<template>
  <div class="timeSlot">
    <div class="timeSlot_top">
      <div class="timeSlot_titleArea">
        <div class="titleArea_title">
          <span class="text">星期/时间</span>
        </div>
        <div class="titleArea_date">
          <div class="date_time">
            <span class="time">00:00 ~ 12:00</span>
            <span class="time">12:00 ~ 24:00</span>
          </div>
          <div class="date_date">
            <ul class="box_title">
              <li
                v-for="item in 24"
                :key="item"
                class="title"
                :class="{hover:judgmentTime(item-1)}"
              >{{ item-1 }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="timeSlot_main">
        <div class="main_titleArea">
          <ul class="titleArea_box">
            <li
              v-for="item in 7"
              :key="item"
              class="text"
              :class="{hover:judgeWeek(item)}"
            >{{ '星期'+item }}</li>
          </ul>
        </div>
        <div class="main_contentArea">
          <ul class="contentArea_box">
            <li
              v-for="(item,index) in creationTimes"
              :key="index"
              class="box_tiem"
            >
              <div
                v-for="(item1,index1) in item"
                :key="index1"
                class="item_div"
                :class="{hover:judgmentTime1(item1),active:activeDates.includes(item1),
                         select:(moveIfon.value === 'select') && moveIfon.lastTimeActiveDates.includes(item1),
                         cancel:(moveIfon.value === 'cancel') && moveIfon.lastTimeActiveDates.includes(item1)
                }"
                @mouseenter="itemDivEnter(item1)"
                @mouseleave="itemDivLeave(item1)"
                @mousedown="itemDivDown(item1)"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="timeSlot_bottom">
      <div class="bottom_title">
        <span class="title">每天</span>
      </div>
      <div class="bottom_box">
        <ul class="box_ul">
          <li
            v-for="(item,index) in 48"
            :key="index"
            class="ul_item"
            :class="{active:judgeEveryDay(index)}"
            @mouseenter="ulItemEnter(item-1)"
            @mouseleave="ulItemLeave"
            @click="ulItemClick(item-1)"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeDate: {
      type: String
    }
  },
  data() {
    return {
      moveDates: [],
      isPress: false,
      activeDates: [],
      isPressDate: false,
      currentMoveDate: null,
      moveIfon: {
        value: null,
        lastTimeActiveDates: []
      }
    }
  },
  computed: {
    creationTimes() {
      const date = new Date()
      const currentWeek = date.getDay()
      const mondayDate = currentWeek > 1 ? new Date(date - (currentWeek - 1) * 24 * 60 * 60 * 1000) : new Date(date - 6 * 24 * 60 * 60 * 1000)
      const dates = []
      const arr = ['一', '二', '三', '四', '五', '六', '日']
      for (let i = 0; i < 7; i++) {
        dates.push([])
        for (let l = 0; l < 48; l++) {
          const date1 = new Date(mondayDate.getFullYear(), mondayDate.getMonth(), mondayDate.getDate() + i, Math.floor(l / 2), l % 2 ? 59 : 30)
          const date2 = new Date(date1 - 30 * 60 * 1000)
          dates[i].push({
            date: date1,
            week: '星期' + arr[i],
            time: `${date2.getHours().toString().padStart(2, '0')}:${date2.getMinutes().toString().padStart(2, '0')}~${date1.getHours().toString().padStart(2, '0')}:${date1.getMinutes().toString().padStart(2, '0')}`
          })
        }
      }

      return dates
    }
  },
  watch: {
    activeDate(newDatas) {
      this.redundancy(newDatas)
    }
  },
  created() {
    console.log(this.creationTimes)
    this.redundancy(this.activeDate)
    window.aaa = this
    window.addEventListener('mouseup', this.itemDivUp)
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.itemDivUp)
  },
  methods: {
    transformation(dates, date1, date2) {
      let str = ''
      for (let i = 0; i < dates.length; i++) {
        for (let l = 0; l < dates[i].length; l++) {
          const clock = dates[i][l].date.getHours() * 60 * 60 * 1000
          const branch = dates[i][l].date.getMinutes() * 60 * 1000
          const s = date1.split(':')
          const s1 = date2.split(':')
          const clock1 = s[0] * 60 * 60 * 1000
          const branch1 = s[1] * 60 * 1000
          const clock2 = s1[0] * 60 * 60 * 1000
          const branch2 = s1[1] * 60 * 1000

          if (clock + branch >= clock1 + branch1 && clock + branch <= clock2 + branch2) {
            str += '1'
          } else {
            str += '0'
          }
        }
      }
      return str
    },
    itemDivEnter(item1) {
      if (this.isPress) {
        let startBit, endBit

        if (this.isPressDate.date.getHours() < item1.date.getHours() && +item1.date > this.isPressDate.date) {
          startBit = this.isPressDate
          endBit = item1
        } else if (this.isPressDate.date.getHours() < item1.date.getHours() && +item1.date < this.isPressDate.date) {
          startBit = this.getItem(item1.week, this.isPressDate.date.getHours(), this.isPressDate.date.getMinutes())
          endBit = this.getItem(this.isPressDate.week, item1.date.getHours(), item1.date.getMinutes())
        } else if (this.isPressDate.date.getHours() > item1.date.getHours() && +item1.date < this.isPressDate.date) {
          startBit = this.getItem(item1.week, item1.date.getHours(), item1.date.getMinutes())
          endBit = this.getItem(this.isPressDate.week, this.isPressDate.date.getHours(), this.isPressDate.date.getMinutes())
        } else if (this.isPressDate.date.getHours() === item1.date.getHours()) {
          if (this.isPressDate.date.getMinutes() < item1.date.getMinutes() || this.isPressDate.date.getMinutes() > item1.date.getMinutes()) {
            if (this.isPressDate.date.getMinutes() < item1.date.getMinutes()) {
              if (+this.isPressDate.date > +item1.date) {
                startBit = this.getItem(item1.week, this.isPressDate.date.getHours(), this.isPressDate.date.getMinutes())
                endBit = this.getItem(this.isPressDate.week, item1.date.getHours(), item1.date.getMinutes())
              } else {
                startBit = this.isPressDate
                endBit = item1
              }
            } else {
              if (+this.isPressDate.date < +item1.date) {
                startBit = this.getItem(this.isPressDate.week, item1.date.getHours(), item1.date.getMinutes())
                endBit = this.getItem(item1.week, this.isPressDate.date.getHours(), this.isPressDate.date.getMinutes())
              } else {
                startBit = item1
                endBit = this.isPressDate
              }
            }
          } else {
            if (+this.isPressDate.date < +item1.date) {
              startBit = this.isPressDate
              endBit = item1
            } else {
              startBit = item1
              endBit = this.isPressDate
            }
          }
        } else {
          startBit = this.getItem(this.isPressDate.week, item1.date.getHours(), item1.date.getMinutes())
          endBit = this.getItem(item1.week, this.isPressDate.date.getHours(), this.isPressDate.date.getMinutes())
        }

        const currentArr = []
        for (let i = 0; i < this.creationTimes.length; i++) {
          for (let l = 0; l < this.creationTimes[i].length; l++) {
            const itemDate = this.creationTimes[i][l]
            const itemDateTime = itemDate.date.getHours() * 60 * 60 * 1000 + itemDate.date.getMinutes() * 60 * 1000
            const startBitTime = startBit.date.getHours() * 60 * 60 * 1000 + startBit.date.getMinutes() * 60 * 1000
            const endBitTime = endBit.date.getHours() * 60 * 60 * 1000 + endBit.date.getMinutes() * 60 * 1000
            const bool1 = +itemDate.date >= +startBit.date && +itemDate.date <= +endBit.date
            const bool2 = itemDateTime >= startBitTime && itemDateTime <= endBitTime

            if (bool1 && bool2) {
              currentArr.push(itemDate)
            }
          }
        }

        this.moveIfon.lastTimeActiveDates = currentArr
      } else if (!this.isPress) {
        this.moveDates.push(item1)
      }
    },
    itemDivLeave(item1) {
      if (!this.isPress) {
        this.moveDates = this.moveDates.filter(item => {
          return item !== item1
        })
      }
    },
    judgmentTime(tiem) {
      const s = this.moveDates.filter(item => {
        return item.date.getHours() === tiem
      })

      return !!s.length
    },
    judgmentTime1(item) {
      return this.moveDates.includes(item)
    },
    judgeWeek(week) {
      const s = this.moveDates.filter(item => {
        const week1 = item.date.getDay() ? item.date.getDay() : 7
        return +week1 === week
      })
      return !!s.length
    },
    ulItemEnter(time) {
      const arr = []
      for (let i = 0; i < this.creationTimes.length; i++) {
        for (let l = 0; l < this.creationTimes[i].length; l++) {
          if (time === l) {
            if (this.creationTimes[i][l].date.getMinutes() === 30) {
              arr.push(this.creationTimes[i][l])
            } else {
              arr.push(this.creationTimes[i][l])
            }
          }
        }
      }
      this.moveDates = arr
    },
    ulItemLeave() {
      this.moveDates = []
    },
    ulItemClick(time) {
      const singleCouple = time % 2
      const s = this.activeDates.filter(item => {
        return !!(item.date.getHours() === Math.floor(time / 2) && item.date.getMinutes() === (singleCouple ? 59 : 30))
      })

      if (s.length === 7) {
        this.activeDates = this.activeDates.filter(item => {
          return !(item.date.getHours() === Math.floor(time / 2) && item.date.getMinutes() === (singleCouple ? 59 : 30))
        })
      } else {
        for (let i = 0; i < this.creationTimes.length; i++) {
          for (let l = 0; l < this.creationTimes[i].length; l++) {
            if (this.creationTimes[i][l].date.getHours() === Math.floor(time / 2) && this.creationTimes[i][l].date.getMinutes() === (singleCouple ? 59 : 30)) {
              this.activeDates.includes(this.creationTimes[i][l]) || this.activeDates.push(this.creationTimes[i][l])
            }
          }
        }
      }

      this.$emit('setActiveDate', {
        text: this.creationTimes
          .map(item => {
            return item
              .map(item1 => {
                return this.activeDates.includes(item1) ? '1' : '0'
              })
              .join('')
          })
          .join(''),

        activeDates: this.activeDates
      })
    },
    judgeEveryDay(time) {
      const singleCouple = time % 2
      const s = this.activeDates.filter(item => {
        return item.date.getHours() === Math.floor(time / 2) && item.date.getMinutes() === (singleCouple ? 59 : 30)
      })
      return s.length === 7
    },
    itemDivDown(item) {
      this.isPress = true
      this.isPressDate = item
      if (this.activeDates.includes(item)) {
        this.activeDates = this.activeDates.filter(item1 => {
          return item1 !== item
        })
        this.moveIfon.value = 'cancel'
      } else {
        this.activeDates.push(item)
        this.moveIfon.value = 'select'
      }
    },
    itemDivUp() {
      this.isPress = false
      this.isPressDate = false

      if (this.moveIfon.value === 'select') {
        this.moveIfon.lastTimeActiveDates.forEach(item => {
          this.activeDates.includes(item) || this.activeDates.push(item)
        })
      } else {
        this.moveIfon.lastTimeActiveDates.forEach(item => {
          if (this.activeDates.includes(item)) {
            this.activeDates.splice(this.activeDates.indexOf(item), 1)
          }
        })
      }

      this.moveIfon = {
        value: null,
        lastTimeActiveDates: []
      }
      console.log('moveDates', this.moveDates)
      this.$emit('setActiveDate', {
        text: this.creationTimes
          .map(item => {
            return item
              .map(item1 => {
                return this.activeDates.includes(item1) ? '1' : '0'
              })
              .join('')
          })
          .join(''),

        activeDates: this.activeDates
      })
    },
    getItem(week, hour, minute) {
      for (let i = 0; i < this.creationTimes.length; i++) {
        for (let l = 0; l < this.creationTimes[i].length; l++) {
          const date = this.creationTimes[i][l]
          if (week === date.week && hour === date.date.getHours() && minute === date.date.getMinutes()) {
            return date
          }
        }
      }
    },
    redundancy(datas) {
      let num = 0

      const activeDate = []
      for (let i = 0; i < this.creationTimes.length; i++) {
        for (let l = 0; l < this.creationTimes[i].length; l++) {
          +datas[num] === +1 && activeDate.push(this.creationTimes[i][l])
          num++
        }
      }
      this.activeDates = activeDate
    }
  }
}
</script>

<style scoped lang="less">
* {
  padding: 0px;
  margin: 0px;
  list-style: none;
  box-sizing: border-box;
}
.timeSlot {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #8c8c8c;
  .hover {
    background-color: #f8f8f8;
    color: #333;
    font-weight: bold;
  }
  .timeSlot_top {
    height: 90%;
    display: flex;
    flex-direction: column;
    border: 1px solid #ebebeb;
    border-radius: 5px;
  }
  .timeSlot_titleArea {
    border-bottom: 1px solid #ebebeb;
    width: 100%;
    display: flex;
    .titleArea_title {
      display: flex;
      align-items: center;
      font-size: 12px;
      justify-content: center;
      width: 13%;
      .text {
      }
    }
    .titleArea_date {
      border-left: 1px solid #ebebeb;
      flex-grow: 1;
      .date_time {
        border-bottom: 1px solid #ebebeb;
        font-size: 12px;
        .time {
          display: inline-block;
          width: 50%;
          text-align: center;
          padding: 5px 0px;
          &:first-child {
            border-right: 1px solid #ebebeb;
          }
        }
      }

      .date_date {
        width: 100%;
        .box_title {
          display: flex;
          width: 100%;
          .title {
            width: 4.16%;
            text-align: center;
            border-left: 1px solid #ebebeb;
            font-size: 12px;
            padding: 3px;
            &:first-child {
              border-left: none;
            }
          }
        }
      }
    }
  }

  .timeSlot_main {
    display: flex;
    width: 100%;
    flex-grow: 1;
    .main_titleArea {
      width: 13%;
      height: 100%;
      border-right: 1px solid #ebebeb;
      .titleArea_box {
        width: 100%;
        height: 100%;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        .text {
          flex-grow: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top: 1px solid #ebebeb;
          &:first-child {
            border-top: none;
          }
        }
      }
    }

    .main_contentArea {
      flex-grow: 1;
      .contentArea_box {
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 100%;
        .box_tiem {
          width: 100%;
          flex-grow: 1;
          height: 100%;
          display: flex;
          border-bottom: 1px solid #ebebeb;
          &:last-child {
            border-bottom: none;
          }
          .item_div {
            width: 4.16%;
            height: 100%;
            display: flex;
            border-right: 1px solid #ebebeb;
            position: relative;
            cursor: pointer;
            &:hover {
              background-color: #fafafa;
              border: 1px solid #c7c7c7;
              z-index: 1;
            }
            &.hover {
              background-color: #fafafa;
              border: 1px solid #c7c7c7;
              z-index: 1;
            }
            &.active {
              background: #ddf3dd;
              border: 1px solid #07c160 !important;
              z-index: 2;
              &:hover {
                background: #8bf58b;
                border: 1px solid #00c961 !important;
                z-index: 2;
              }
            }
            &.select {
              background: rgba(83, 155, 95, 0.3);
              z-index: 3;
            }
            &.cancel {
              background: rgba(88, 90, 88, 0.3);
              z-index: 3;
            }
            &:last-child {
              border-right: none;
            }
            .div_span {
              &:first-child {
              }
            }
          }
        }
      }
    }
  }

  .timeSlot_bottom {
    height: 10%;
    border: 1px solid #ebebeb;
    border-radius: 5px;
    margin-top: 20px;
    width: 100%;
    display: flex;
    .bottom_title {
      width: 15%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #ebebeb;
      .title {
      }
    }

    .bottom_box {
      width: 100%;
      .box_ul {
        width: 100%;
        display: flex;
        height: 100%;
        .ul_item {
          border-right: 1px solid #ebebeb;
          width: 4.16%;
          height: 100%;
          position: relative;
          &:hover {
            background-color: #fafafa;
            border: 1px solid #c7c7c7;
            z-index: 1;
          }
          &.active {
            background: #ddf3dd;
            border: 1px solid #07c160 !important;
            z-index: 2;
          }
          cursor: pointer;
          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
}
</style>
